import request from '@/http/request'
import {
  studentMockGetCourseMockList,
  studentMockGetStudentMockList,
  studentMockGetMockRecordLog,
  studentMockGetStudentMockExport,
  studentMockGetMyMockList,
  studentMockGetMessageSendGroupCount,
  studentMockSendMessage,
  getPlanList
} from '@/http/api'


export const studentMockGetCourseMockListApi = (data) => {
  return request({
    url: studentMockGetCourseMockList,
    data
  })
}

export const studentMockGetStudentMockListApi = (data) => {
  return request({
    url: studentMockGetStudentMockList,
    data
  })
}

export const studentMockGetMockRecordLogApi = (data) => {
  return request({
    url: studentMockGetMockRecordLog,
    data
  })
}

export const studentMockGetStudentMockExportApi = (data) => {
  return request({
    url: studentMockGetStudentMockExport,
    data
  })
}

export const studentMockGetMyMockListApi = (data) => {
  return request({
    url: studentMockGetMyMockList,
    data
  })
}

export const getPlanListApi = (data) => {
  return request({
    url: getPlanList,
    data
  })
}

export const studentMockGetMessageSendGroupCountApi = (data) => {
  return request({
    url: studentMockGetMessageSendGroupCount,
    data
  })
}

export const studentMockSendMessageApi = (data) => {
  return request({
    url: studentMockSendMessage,
    data
  })
}

